import { render, staticRenderFns } from "./MobileBottomBar.vue?vue&type=template&id=c3150c12&scoped=true&"
import script from "./MobileBottomBar.vue?vue&type=script&lang=js&"
export * from "./MobileBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomBar.vue?vue&type=style&index=0&id=c3150c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3150c12",
  null
  
)

export default component.exports